/**
 * A set of predetermined color schemes for use with Gauge components.
 */
export class GaugeColors {

    public static Green = 'hsl(125, 42%, 36%)';
    public static Yellow = 'hsl(35, 84%, 54%)';
    public static Red = 'hsl(345, 69%, 46%)';

    /** A color scheme for: Green, Yellow, Red */
    public static readonly GYR: string[] = [GaugeColors.Green, GaugeColors.Yellow, GaugeColors.Red];

    /** A color scheme for: Red, Yellow, Green */
    public static readonly RYG: string[] = [GaugeColors.Red, GaugeColors.Yellow, GaugeColors.Green];
}
